import PropTypes from 'prop-types';
import React from 'react';

import Ad from '../../../../models/banner/Ad';
import { modelOf } from '../../../../prop-types';
import { ViewBreakpointMinWidth } from '../../../../types/ViewBreakpoint';

const BannerMediaImage = ({ banner, isSmallest }) => {
  return (
    <picture className="Banner__media">
      {banner.mobile_image && (
        <source
          media={`(max-width:${ViewBreakpointMinWidth.SM}px)`}
          srcSet={encodeURI(banner.mobile_image)}
        />
      )}
      <img
        className={
          isSmallest && banner.mobile_image
            ? 'Banner__background-mobile-image'
            : 'Banner__background-image'
        }
        src={banner.image}
        alt={banner.seo_description}
        style={{
          aspectRatio: banner.aspectRatioCSS,
        }}
      />
    </picture>
  );
};

BannerMediaImage.propTypes = {
  banner: modelOf(Ad).isRequired,
  isSmallest: PropTypes.bool.isRequired,
};

export default BannerMediaImage;
